import Resource from '@/api/resources/Resource'

class SampleMicroAttachmentService extends Resource {
    async addAttachment(laboratoryId, caseId, sampleId, request) {
        const response = await this.axios.post(
            `/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/micro/attachments`,
            request)
        return response.data
    }

    async getAttachments(laboratoryId, caseId, sampleId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/micro/attachments`)
        return response.data
    }

    async deleteAttachment(laboratoryId, caseId, sampleId, descriptionAttachmentId) {
        const response = await this.axios.delete(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/micro/attachments/${descriptionAttachmentId}`)
        return response.data
    }
}

export default new SampleMicroAttachmentService()
